import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  FundOutlined,
} from '@ant-design/icons';
import MainLayout from '../../layouts/MainLayout';

const items = [
  { title: 'گزارش مالی', desc: 'خلاصه مالی و نمودار روند', path: '/reports/finance', icon: LineChartOutlined, accent: 'from-violet-500 to-indigo-600' },
  { title: 'درآمد در مقابل هزینه', desc: 'مقایسه درآمد و هزینه', path: '/reports/income-expense', icon: BarChartOutlined, accent: 'from-emerald-500 to-teal-600' },
  { title: 'گزارش مرخصی', desc: 'آمار مرخصی کارکنان', path: '/reports/leaves', icon: CalendarOutlined, accent: 'from-amber-500 to-orange-600' },
  { title: 'سهمیه مرخصی کارکنان', desc: 'سهمیه به تفکیک ماه', path: '/reports/leave-quota', icon: CalendarOutlined, accent: 'from-sky-500 to-blue-600' },
  { title: 'گزارش حضور و غیاب', desc: 'حضور، غیبت و ساعت کاری', path: '/reports/attendance', icon: ClockCircleOutlined, accent: 'from-cyan-500 to-cyan-700' },
  { title: 'گزارش هزینه‌ها', desc: 'هزینه و دسته‌بندی', path: '/reports/expenses', icon: PieChartOutlined, accent: 'from-rose-500 to-pink-600' },
  { title: 'گزارش معاملات', desc: 'قیف و لیست معاملات', path: '/reports/leads', icon: FundOutlined, accent: 'from-purple-500 to-fuchsia-600' },
  { title: 'گزارش فروش', desc: 'فاکتورهای فروش', path: '/reports/sales', icon: DollarOutlined, accent: 'from-lime-600 to-green-700' },
];

const ReportsIndex = () => {
  const navigate = useNavigate();

  return (
    <MainLayout>
      <div className="custom-font max-w-6xl mx-auto px-1 sm:px-0">
        <section
          className="mb-7 rounded-2xl border border-slate-200/90 bg-white shadow-sm dark:border-slate-600 dark:bg-slate-900 overflow-hidden"
          aria-labelledby="reports-overview-heading"
        >
          <div className="relative px-5 py-6 sm:px-8 sm:py-8">
            <div
              className="pointer-events-none absolute inset-y-0 right-0 w-1 bg-gradient-to-b from-indigo-500 via-violet-500 to-indigo-600 opacity-90"
              aria-hidden
            />
            <div className="relative flex flex-wrap items-center gap-5 sm:gap-6">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-600 text-white shadow-lg shadow-indigo-500/25 ring-4 ring-indigo-500/10 dark:ring-indigo-400/15">
                <BarChartOutlined className="text-[26px] sm:text-[28px]" />
              </div>
              <div className="min-w-0 flex-1">
                {/* <p className="m-0 mb-1 text-xs font-medium tracking-wide text-indigo-600/90 dark:text-indigo-400/90">
                  گزارش‌ها
                </p> */}
                <h1 id="reports-overview-heading" className="m-0 text-xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-2xl">
                  نمای کلی گزارشات
                </h1>
              </div>
            </div>
          </div>
        </section>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(({ title, desc, path, icon: Icon, accent }) => (
            <button
              key={path}
              type="button"
              onClick={() => navigate(path)}
              className="text-right rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 shadow-sm hover:shadow-md transition-shadow p-4 sm:p-5 flex flex-col gap-3 min-h-[120px] group"
            >
              <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${accent} flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform`}>
                <Icon className="text-xl" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="m-0 text-base font-semibold text-slate-800 dark:text-slate-100">{title}</h3>
                <p className="m-0 mt-1 text-sm text-slate-500 dark:text-slate-400 leading-snug">{desc}</p>
              </div>
              <span className="text-sm self-end text-indigo-600 dark:text-indigo-400 font-medium">
                مشاهده ←
              </span>
            </button>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default ReportsIndex;
